export const SET_GLOBAL_TRAITS = 'SET_GLOBAL_TRAITS';